import { environment } from '../../../environments/environment';
import { FileStoreService } from '../../shared/_services/file-store.service';
import { Delete } from 'angular-feather/icons';
import { Prodotto } from '../../Progetti/Models/Prodotto';
import { ProdottiStoreService } from '../../Progetti/_services/prodotti-store.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';
import { ApiPathsService } from 'src/app/api-paths.service';
import { IDropdownSettings } from "../../../LibrerieCustom/MultiselectDropdown";
import { ToastrService } from "ngx-toastr";
import { ApiRestService as MaterialiApiRestService } from "../../Materiali/api-rest.service";
import { ApiRestService } from '../../Progetti/_services/api-rest.service';

@Component({
  selector: 'app-lista-prodotti-card',
  templateUrl: './lista-prodotti-card.component.html',
  styleUrls: ['./lista-prodotti-card.component.scss']
})
export class ListaProdottiCardComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  showAllText: string = "Mostra Eliminati"
  showAllUser: boolean = false;
  type = "";
  ricercaform: FormGroup;
  submittedricerca;
  collectionSize = 0;
  page = 1;
  Tipo: number;
  pageSize: number = 50;
  pagesizeserver = 4; // pagine da precaricare dal server
  newpagegenerated: number;
  Prodotti: Prodotto[] = []
  Backup: Prodotto[] = []
  Parti_categorie: { partiList: any[], categoriaObject: any, cat_id: number }[] = []
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    singleOutput: true,
    idField: 'id',
    textField: 'label',
  };
  MaterialeDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    singleOutput: true,
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: true,
    textField: "nome",
  };
  @Output() AddClick = new EventEmitter<Prodotto>();
  @Input() tipoProgetto?: any;
  constructor(private route: ActivatedRoute,
    public router: Router,
    private progettistore: ProdottiStoreService,
    private paginationService: ServerPaginationService,
    private formBuilder: FormBuilder,
    private filestore: FileStoreService,
    private materialiApiRestService: MaterialiApiRestService,
    public apiPaths: ApiPathsService,
    private toastService: ToastrService,
    private apiRest: ApiRestService
  ) {
    this.ricercaform = this.formBuilder.group({
      cerca: [''],
      size: [this.pageSize],
    });

  }
  get f() { return this.ricercaform.controls; }
  ngOnInit() {
    console.log("Tipo Progetto: ", this.tipoProgetto);
    this.progettistore.getCategorieProdotti();
    this.progettistore.getUnitaDiMisura();// TODO: walkaround pe lista unita
    this.route.params.subscribe(data => {
      this.type = data['type'];
      this.refreshTable(1);
    })
    this.subscriptions.add(this.progettistore.$showAllProdotti.subscribe(data => this.showAllUser = data));


    this.apiPaths.ClassicGet('/prodotti/schede/categorie').subscribe(data => {
      data.forEach(categoria => {
        this.materialiApiRestService.GetParti({ page: 0, size: 50, cat_id: categoria.id }).subscribe(materiali => {
          this.Parti_categorie.push({ partiList: materiali?.data ?? [], categoriaObject: categoria, cat_id: categoria.id });
        });
      });
      this.refreshTable(1);
    });
  }

  showDeleted() {
    this.progettistore.updateShowAllProdotti(!this.showAllUser);
    this.refreshTable(1);
    if (this.showAllUser) {
      this.showAllText = "Nascondi eliminati";
    } else {
      this.showAllText = "Mostra eliminati";
    }
  }

  sizeChanged() {
    this.pageSize = parseInt(this.f.size.value);
    this.refreshTable(1);
  }
  Search() {
    this.submittedricerca = true;
    if (this.ricercaform.invalid) { return; }
    this.refreshTable(1);
    this.submittedricerca = false;
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page) {
    this.apiRest.getProdotti(new Prodotto((page - 1) / this.pagesizeserver + 1, this.pagesizeserver * this.pageSize, parseInt(this.type), 'asc', this.f.cerca.value, null, null, null, null, null, null, null, this.Tipo)).subscribe(data => {
      this.Prodotti = data.data?.filter(x => !this.tipoProgetto || this.tipoProgetto.id != "V" || (x.taglie?.some(taglia => taglia.disponibili > 0) ?? true)).map(y => {
        y.taglie = y.taglie?.filter(taglia => !this.tipoProgetto || this.tipoProgetto.id != "V" || taglia.disponibili > 0);
        y['variazioniDistinta'] = this.GetSchede(y).map(z => Object.assign({}, z));
        return y;
      });
      this.Backup = this.Prodotti?.map(x => x) ?? [];
      this.collectionSize = data.total;
    });
  }
  requestdata(page): Prodotto {
    if (this.f.cerca.value != "") {
      return new Prodotto((page - 1) / this.pagesizeserver + 1, this.pagesizeserver * this.pageSize, parseInt(this.type), 'asc', this.f.cerca.value);
    } else {
      return new Prodotto((page - 1) / this.pagesizeserver + 1, this.pagesizeserver * this.pageSize, parseInt(this.type), 'asc');
    }
  }
  Click(value: Prodotto) {
    if (!value?.taglie?.length) {
      this.AddToOrder(value);
      return;
    }
    var taglie = value.taglie?.filter(taglia => taglia?.qty);
    if (!taglie?.length) {
      this.toastService.warning("Indicare la quantità di almeno una taglia per questo prodotto.");
      return;
    }
    console.log("taglie Selezionate", taglie);
    taglie.forEach(taglia => {
      this.AddTagliaToOrder(value, taglia);
    });
  }
  AddTagliaToOrder(value: Prodotto, taglia: any) {
    if (!(taglia?.disponibili > 0 && taglia?.disponibili >= taglia.qty) && this.tipoProgetto?.id == "V") {
      this.toastService.warning(`La quantità da lei desiderata per la Taglia ${taglia?.taglia} non è al momento disponibile, la quantità disponibile è pari a ${taglia?.disponibili ?? 0}.`);
      return;
    }
    if (this.tipoProgetto?.id == "V") // perche solo se ordine di acquisto sottraggono il disponibili dei prodotti finiti (flag spedire)
      taglia.disponibili -= taglia.qty;
    this.AddToOrder(Object.assign(value, { taglia: taglia, qty: taglia.qty }));
    taglia.qty = undefined;
  }

  AddToOrder(prod: Prodotto, defaultValue: number = 1) {
    var errorMex = '';
    prod['variazioniDistinta']?.forEach(Variazioni => {
      var CatValue = prod?.schedaLavorazione?.find(x => x?.cat_id == Variazioni?.cat_id);
      if (!CatValue || !Variazioni.parteObject) {
        errorMex += ` Indicare il tipo di ${Variazioni.categoriaObject?.categoria}. \n`
        return;
      }
      CatValue.parte_id = Variazioni.parteObject?.id;
      CatValue.parteObject = Variazioni.parteObject;
    });
    if (errorMex?.length) {
      this.toastService.warning(errorMex);
      return;
    }
    this.AddClick.emit(Object.assign({}, prod));
    prod.qty = defaultValue;
  }

  GetSchede(prodotto: Prodotto) {
    var prod = this.Prodotti?.find(x => x.id == prodotto.id);
    var schede = prod?.schedaLavorazione?.filter(x => !x.parte_id && x.qta > 0) ?? [];
    var result = schede.map(scheda => {
      scheda.partiList = (Object.assign({}, this.Parti_categorie?.find(x => x.cat_id == scheda.cat_id))?.partiList) ?? [];
      return scheda
    });
    return result;
  }

  checkParte(Variazioni: any, parte, prodotto: Prodotto) {
    Variazioni.partiList.forEach(part => {
      part.selected = parte.id == part.id ? parte.selected : false;
    })
    var prod = this.Prodotti?.find(x => x.id == prodotto.id);
    if (prod?.schedaLavorazione?.find(x => x?.cat_id == Variazioni?.categoriaObject?.id))
      prod.schedaLavorazione.find(x => x.cat_id == Variazioni.categoriaObject?.id).parte_id = Variazioni.partiList.find(x => x.selected)?.id ?? undefined;
  }


  qtyplus(c) { !c.qty ? c.qty = 1 : c.qty++; }
  qtyminus(c) {
    if (c.qty > 1)
      c.qty--;
  }
}
